<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()" aria-label="Go back">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">SCOUT DETAILS</span>
    <span class="spacer"></span>
    <button mat-icon-button aria-label="Refresh user details" (click)="loadUser()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (!isLoading && userDetails) {
    <mat-card appearance="outlined" style="margin-top: 12px;">
      <mat-card-header>
        <mat-card-title>{{ getDisplayName() }}</mat-card-title>
        <mat-card-subtitle>{{ getUserEmail() }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="details-grid">
          <div class="details-label">User ID</div>
          <div>{{ userId }}</div>

          <div class="details-label">Username</div>
          <div>{{ getUserName() || '-' }}</div>

          <div class="details-label">Email</div>
          <div>{{ getUserEmail() || '-' }}</div>

          <div class="details-label">Locked</div>
          <div>{{ isLocked() }}</div>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (!isLoading && !userDetails) {
    <mat-card appearance="outlined" style="margin-top: 12px;">
      <mat-card-content>
        Unable to load user details.
      </mat-card-content>
    </mat-card>
  }
</div>
